<div #content class="widget-content">
    <p class="text-color">EIA Weekly Petroleum Status Report</p>
    <div class="link">
        <a target="_blank" href="https://www.eia.gov/petroleum/supply/weekly/">
            <fa-icon icon="external-link-alt"></fa-icon>
        </a>
    </div>
</div>
